module.exports = __webpack_public_path__ + "img/oceanbase.6df59ad5.svg";